module.exports = {"130923100":"东光镇","130923101":"连镇镇","130923102":"找王镇","130923103":"秦村镇","130923104":"灯明寺镇","130923105":"南霞口镇","130923106":"大单镇","130923107":"龙王李镇","130923201":"于桥乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130923.json
// module id = 304
// module chunks = 0